export enum PublicLinksEnum {
    solicitariDgitl = 'public/solicitari/dgitl',
    solicitariUrbanism = 'public/solicitari/urbanism',
    solicitariAutorizariComerciale = 'public/solicitari/autorizari-comerciale',
    programariOnline = 'public/programari-online',

    declaratii = 'public/declaratii/',
    cariera = 'public/cariera/',
    achizitii = 'public/achizitii-publice/',
}